import moment from 'moment-timezone';

export const DATE_FORMAT_COMPACT = 'YYYYMMDD';
export const DATE_FORMAT_SLASH = 'YYYY/MM/DD';
export const DATE_FORMAT_FULL = 'YYYY/MM/DD HH:mm:ss';
export const TOKYO_TIMEZONE = 'Asia/Tokyo';

export const formatDate = (date: string | number | undefined, format: string): string => {
  if (!date || (typeof date === 'string' && date.length === 0)) {
    return '';
  }
  return moment.tz(date, TOKYO_TIMEZONE).format(format);
};

/**
 * UTC ISO 8601 datetime string to JST datetime string
 */
export function formatUtcIsoToJstDateTime(utcIso: string): string {
  const m = moment.utc(utcIso);
  return m.isValid() ? m.tz(TOKYO_TIMEZONE).format(DATE_FORMAT_FULL) : utcIso;
}
